import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import useClassNames from 'helpers/hooks/useClassNames';
import { renderTextWithLineBreaks } from 'helpers/utils/textFormatter';
import { HeadingProps } from './types';

const Heading: React.FC<HeadingProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  buttonVariant = 'primary',
  alignment = { mobile: 'center', tablet: 'center', desktop: 'center' },
  theme = 'dark',
  className = '',
}) => {
  const containerClassName = useClassNames([
    'w-full py-32 md:py-32 lg:py-64',
    theme === 'dark' ? 'bg-inverted text-white' : 'bg-white',
    className,
  ]);

  // Content container classes with alignment
  const contentClassName = useClassNames([
    'container',
    // Mobile alignment
    alignment.mobile === 'left' ? 'text-left' : null,
    alignment.mobile === 'center' ? 'text-center' : null,
    alignment.mobile === 'right' ? 'text-right' : null,

    // Tablet alignment
    alignment.tablet === 'left' ? 'md:text-left' : null,
    alignment.tablet === 'center' ? 'md:text-center' : null,
    alignment.tablet === 'right' ? 'md:text-right' : null,

    // Desktop alignment
    alignment.desktop === 'left' ? 'lg:text-left lg:ml-0 lg:mr-auto' : null,
    alignment.desktop === 'center' ? 'lg:text-center lg:mx-auto' : null,
    alignment.desktop === 'right' ? 'lg:text-right lg:ml-auto lg:mr-0' : null,
  ]);

  return (
    <div className={containerClassName}>
      <div className={contentClassName}>
        <div className="flex flex-col gap-16">
          {title && <h2 className="body-text-2xlarge font-medium">{title}</h2>}
          {description && (
            <div className="description-container">
              {renderTextWithLineBreaks(description, 'body-text-large leading-6')}
            </div>
          )}
        </div>

        {buttonText && (
          <div className="mt-32">
            <Link buttonVariant={buttonVariant} link={buttonLink} className="inline-block">
              {buttonText}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Heading;
